import { ButtonActionBtn, ButtonActionContainer } from "./ButtonAction.styled";
import { observer } from "mobx-react";
import { useNavigate } from "react-router-dom";
import { GrandChartMyDayStore } from "../../../../../stores/grand-charts/grand-charts-my-day/grand-chart-my-day.store";
import { useTranslation } from "react-i18next";

interface ButtonActionProps {
	grandChartMyDayStore: GrandChartMyDayStore;
}

export const ButtonAction = observer(({ grandChartMyDayStore }: ButtonActionProps) => {
	const { t } = useTranslation();

	const navigate = useNavigate();

	const handleOnGoLesson = () => {
		navigate(`/cabinet/lessons/${grandChartMyDayStore.lastLessonData?.lesson_uuid}`);
	};

	const getTitleButton = () => {
		return grandChartMyDayStore.lastLessonData?.date ? `continue_learning` : `start_learning`;
	};

	return (
		<ButtonActionContainer>
			<ButtonActionBtn onClick={handleOnGoLesson}>{t(`buttons.${getTitleButton()}`)}</ButtonActionBtn>
		</ButtonActionContainer>
	);
});
